import { Navigate, Outlet } from "react-router-dom";
import { Authorize } from "./Utility";

function PrivateRoutes() {
  return Authorize() ? <Outlet /> : <Navigate to="/" />;
}
export default PrivateRoutes;
